(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afo-collections-index"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('afo-collections-index')) {
    customElements.define(
      'afo-collections-index',
      class AfoCollectionsIndex extends HTMLElement {
        connectedCallback() {
          this.images = [...this.querySelectorAll('[data-afo-stage]')];
          if (this.images.length) this.activate(0);
          this.onOver = (event) => {
            const row = event.target.closest('[data-afo-idx]');
            if (row) this.activate(+row.dataset.afoIdx);
          };
          this.addEventListener('pointerover', this.onOver);
          this.addEventListener('focusin', this.onOver);
        }

        disconnectedCallback() {
          this.removeEventListener('pointerover', this.onOver);
          this.removeEventListener('focusin', this.onOver);
        }

        activate(idx) {
          this.images.forEach((img) => {
            img.classList.toggle('is-active', +img.dataset.afoStage === idx);
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
